import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { COLOR } from "../../../../config/constant";

const ChartBar = (props) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart
        data={props.data}
        margin={{
          top: 25,
          right: 10,
          left: -20,
          bottom: 0,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={props.dataKeyX || "_id"} />
        <YAxis />
        <Tooltip />
        {/* {props.dataYKey.map((data, idx) => (
          ))} */}
        <Bar dataKey="count" fill={props.fill || COLOR.INFO} />
        <Line
          type="monotone"
          dataKey="count"
          stroke={`${COLOR.PRIMARY}70`}
          strokeWidth="2"
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default ChartBar;
